import axios from 'axios'
import * as utils from './api-utils'

export default {
  getWashRequestLimits(obj) {
    return axios.get(utils.getApiUrl(`/admin/washRequestLimits`), {
      params: obj || {}
    })
  },
  getWashRequestLimit(obj) {
    return axios.get(utils.getApiUrl(`/admin/washRequestLimit`), {
      params: obj || {}
    })
  },
  setWashRequestLimit(data) {
    return axios.post(utils.getApiUrl(`/admin/washRequestLimit`), data)
  },
  cancelWashRequestLimit(id) {
    return axios.delete(utils.getApiUrl(`/admin/washRequestLimit/${id}`))
  },
}
